import { CheckBoxRememberMe } from "/app/libraries/arcana/src/atoms/CheckBox/Templates/index.ts"

import { useUnit } from 'effector-react'
import { $rememberMe, toggleRememberMe } from '../model'
import { translations } from '../sign-in-by-email/model'

export const RememberMe = ({ disabled = false }: { disabled?: boolean }) => {
  const formTranslations = useUnit(translations.$signInByEmailTranslations)
  const rememberMe = useUnit($rememberMe)
  const onChangeRememberMe = useUnit(toggleRememberMe)

  return (
    <CheckBoxRememberMe
      label={formTranslations.rememberMe}
      checked={rememberMe}
      disabled={disabled}
      onChange={onChangeRememberMe}
    />
  )
}
